export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolg"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
}